export type ImportedItem = {
  name: string;
  short_description: string;
  description: string;
  website_url: string;
  category: string;
  location: string;
  tags: string[];
  featured: boolean;
  status: "draft" | "published";
};

export function parseCsv(text: string): ImportedItem[] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let quoted = false;
  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    const next = text[index + 1];
    if (character === '"' && quoted && next === '"') { cell += '"'; index += 1; continue; }
    if (character === '"') { quoted = !quoted; continue; }
    if (character === "," && !quoted) { row.push(cell); cell = ""; continue; }
    if ((character === "\n" || character === "\r") && !quoted) {
      if (character === "\r" && next === "\n") index += 1;
      row.push(cell); if (row.some((value) => value.trim())) rows.push(row); row = []; cell = ""; continue;
    }
    cell += character;
  }
  row.push(cell); if (row.some((value) => value.trim())) rows.push(row);
  const headerRow = rows.shift();
  if (!headerRow) return [];
  const headers = headerRow.map((header) => header.trim().toLowerCase().replace(/[\s-]+/g, "_"));
  const aliases: Record<string, string> = { title: "name", url: "website_url", website: "website_url", summary: "short_description", tags: "tags" };
  return rows.map((values) => {
    const record: Record<string, string> = {};
    headers.forEach((header, index) => { record[aliases[header] ?? header] = values[index]?.trim() ?? ""; });
    return {
      name: record.name ?? "",
      short_description: record.short_description ?? "",
      description: record.description ?? "",
      website_url: record.website_url ?? "",
      category: record.category || "General",
      location: record.location ?? "",
      tags: (record.tags ?? "").split(/[|;]/).map((tag) => tag.trim()).filter(Boolean),
      featured: /^(true|yes|1)$/i.test(record.featured ?? ""),
      status: (record.status?.toLowerCase() === "draft" ? "draft" : "published") as "draft" | "published",
    };
  }).filter((item) => item.name.length >= 2);
}

export const CSV_TEMPLATE = "name,short_description,description,website_url,category,location,tags,featured,status\nExample tool,A short one-line summary,A fuller description,https://example.com,Tools,Remote,AI|Design,true,published";
